export default "__VITE_ASSET__CVNooKox__"